import { render, staticRenderFns } from "./AddProductionBatch.vue?vue&type=template&id=4410e10c&scoped=true&"
import script from "./AddProductionBatch.vue?vue&type=script&lang=js&"
export * from "./AddProductionBatch.vue?vue&type=script&lang=js&"
import style0 from "./AddProductionBatch.vue?vue&type=style&index=0&id=4410e10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4410e10c",
  null
  
)

export default component.exports